import { noop } from "lodash";
import React, { ReactElement } from "react";
import EventCardColumnMessage from "./EventCardColumnMessage";

type EventCardColumnGroupProps = {
  updating?: boolean;
  name: string;
  onFlexibilityChange?: (eventId: string, isFlexible: boolean) => void;
};

export const isEventCardColumnGroup = (
  component: React.ReactNode,
): component is ReactElement<EventCardColumnGroupProps> => {
  if (
    !component ||
    !React.isValidElement(component) ||
    typeof component.type === "string" ||
    typeof component.type === "number" ||
    component.type.name !== EventCardColumnGroup.name
  ) {
    return false;
  }

  return true;
};

const EventCardColumnGroup = ({
  children,
  updating = false,
  name,
  onFlexibilityChange = noop,
}: React.PropsWithChildren<EventCardColumnGroupProps>) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child as JSX.Element, {
        updating,
        onFlexibilityChange,
        ...child.props,
      });
    }
    return child;
  });

  return (
    <>
      {name && <div className="cw-body-base cw-px-1 cw-py-2">{name}</div>}
      {!React.Children.count(children) && (
        <div className="cw-ml-3">
          <EventCardColumnMessage message="no meetings" />
        </div>
      )}
      {childrenWithProps}
    </>
  );
};

export default EventCardColumnGroup;
